const NAME = "CONSENT_TYPES";

export default NAME;
